import { Time } from '@eagle/common';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { Nullable } from '../types';
import { getSpeedLimit, LatLngWaypoint } from '../util';
import { useConfig } from './use-config';

interface UseSpeedLimitQueryOptions {
  waypoints: LatLngWaypoint[];
  heading?: number;
  mode?: string;
}

export const useSpeedLimitQuery = ({ waypoints, heading, mode = 'car' }: UseSpeedLimitQueryOptions): UseQueryResult<Nullable<number>> => {
  const config = useConfig();

  return useQuery({
    queryKey: ['speed-limit', waypoints, heading, mode, config.hereMaps?.apiKey],
    queryFn: () => getSpeedLimit(waypoints, heading, mode, config.hereMaps?.apiKey),
    enabled: waypoints.length > 0,
    staleTime: Time.minutes(1),
  });
};
